import { uniqBy } from "lodash";
import moment from "moment";
import { getScripbyTokenAndMktSegId } from "../../apis";
import { getUserAlerts } from "../../apis/alert_nodeengine";
import { getApiExchangeNameFromMktSegId, getDynamicParamsForToFixed, getMktSegIdFromMappedMktSegId } from "../../utils/global_functions";
import { ALERT_STATUS, BUSINESS_LAYER_RESPONSE, SET_ALERT_FIELDS } from "../../utils/global_variables";

async function _getAlerts(user_id) {
    // user_id===> ID of user


    /*{  function Description  ===>  Basically this function call for getting all Alerts (Actve and Trigged Alert)
      for Alert we need additional data like expiry date option chain and decimal locator etc. for this additional data
      we call another api e.i. getScripbyTokenAndMktSegId after getting additional data it combined both data
      after combining it seprated active and trigged alert  by comparing one key e.i. triggered .If triggered===1 means alert is trigged
      and triggered === 1 means aleret is active }*/


    try {
        const objresp = await getUserAlerts(user_id);


        const arrAllscrip = await objresp?.data?.data?.length > 0 && objresp?.data?.data?.map((item) => ({ mkt: getApiExchangeNameFromMktSegId(getMktSegIdFromMappedMktSegId(item.condition[0].operand1.marketsegment)), token: item.condition[0].operand1.token, mktIdToken: item.condition[0].operand1.marketsegment + '_' + item.condition[0].operand1.token }));
        const arrUniqueAlert = uniqBy(arrAllscrip, 'mktIdToken')?.map((scrip) => ({ mkt: scrip?.mkt, token: scrip?.token }));

        const objRespofScrip = arrUniqueAlert?.length > 0 && await getScripbyTokenAndMktSegId(arrUniqueAlert);
        const arrAllAlertData = [];
        objresp?.data?.data?.sort((a, b) => new Date(b.createDate) - new Date(a.createDate));
        if (objresp?.data?.data?.length > 0 && objRespofScrip?.data?.result?.length > 0) {


            objresp?.data?.data?.forEach((alert, index) => {
                const nIndex = objRespofScrip?.data?.result?.findIndex((scrip) => scrip?.nMarketSegmentId === alert?.condition[0].operand1.marketsegment && scrip?.nToken === alert?.condition[0]?.operand1?.token);
                const matchedScrip = objRespofScrip?.data?.result[nIndex];
                if (matchedScrip) {
                    const objAlertScrip = {
                        segmentId: matchedScrip?.MktSegId,
                        nToken: matchedScrip?.nToken,
                        mktIdToken: matchedScrip?.MktSegId + '_' + matchedScrip?.nToken,
                        symbol: matchedScrip?.sSymbol,
                        exchange: matchedScrip?.sExchange,
                        series: matchedScrip?.sSeries,
                        optionType: matchedScrip?.sOptionType,
                        expiryDate: matchedScrip?.nExpiryDate1,
                        securityDesc: matchedScrip?.sSecurityDesc,
                        decimalLocator: matchedScrip?.DecimalLocator,
                        instrument: matchedScrip?.sInstrumentName,
                        nStrikePrice1: matchedScrip?.nStrikePrice1,
                        assetToken: matchedScrip?.nAssetToken,
                        amount: alert?.condition[0]?.operand1?.field?.toUpperCase()?.includes('QUANTITY') ? alert?.condition[0].operand2.value : (alert?.condition[0].operand2.value / matchedScrip?.DecimalLocator)?.toFixed(getDynamicParamsForToFixed(matchedScrip?.ExchangeSegment)),
                        //Azeem K :17-04-2024 : BT-107432 Breeze - Alerts  --Start                                                                                                                                                               
                        alertCondition: (`${SET_ALERT_FIELDS.FACTOR1[alert?.condition[0]?.operand1?.field?.toUpperCase()]?.value} ${alert.condition[0].operator}  ${alert?.condition[0]?.operand2.field === 'USE_VALUE' ? (SET_ALERT_FIELDS.FACTOR1[alert?.condition[0]?.operand1?.field?.toUpperCase()]?.value?.toUpperCase().includes('QUANTITY') ? (alert?.condition[0].operand2.value) : (alert?.condition[0].operand2.value / matchedScrip?.DecimalLocator)?.toFixed(getDynamicParamsForToFixed(matchedScrip?.ExchangeSegment))) : SET_ALERT_FIELDS.FACTOR2[alert?.condition[0].operand2.field?.toUpperCase()]?.value}`)?.toString(),
                        //Azeem K :17-04-2024 : BT-107432 Breeze - Alerts  --End
                        status: alert.triggered === 0 ? ALERT_STATUS.ACTIVE : ALERT_STATUS.TRIGGERED,
                        operator: alert?.condition[0].operator,
                        displayCreateDate: moment(alert?.createDate).format("hh:mm A, DD MMM 'YY"),
                        createDate: alert?.createDate,
                        expiration: alert?.expiration === -1 ? moment()?.format("DD MMM 'YY") : alert?.expiration?.toUpperCase() == 'GTC' ? 'GTT' : alert?.expiration,
                        serverAlertId: alert?.serverAlertId,
                        alertType: alert?.data?.alertType,
                        category: alert?.data?.category,
                        remarks: alert?.data?.remarks,
                        triggered: alert?.triggered,
                        factor1: alert?.condition[0]?.operand1?.field?.toUpperCase(),
                        factor2: alert?.condition[0]?.operand2?.field?.toUpperCase(),
                        triggeredTime: moment(alert?.condition[0]?.triggeredTime).format("hh:mm A, DD MMM 'YY"),
                        sISINCode: matchedScrip?.sISINCode,  //Azeem K : 16-12-2023 :added ISIN code
                        //Azeem Khan : 23-04-2024 : BT-107432 -  Breeze - Alerts - Start
                        UniqueId: alert.UniqueId,
                        ExchangeSegment: matchedScrip?.ExchangeSegment,
                        scripObj: matchedScrip,
                        workerId: alert?.workerId,
                        entryTime: alert?.entryTime,
                        ltp: (0).toFixed(getDynamicParamsForToFixed(matchedScrip?.ExchangeSegment)),
                        changeInPrice: (0).toFixed(getDynamicParamsForToFixed(matchedScrip?.ExchangeSegment)),
                        changeInPercent: '0.00',
                        alertUniqueId: index      //Deepti B. :As per discussion with Indresh, index is consider as unique Id
                        //Azeem Khan : 23-04-2024 : BT-107432 -  Breeze - Alerts - End
                    };
                    arrAllAlertData?.push(objAlertScrip);
                }
            });
        }
        const hotList = new Map();

        // Create a object of hotList data and Map with keys
        // arrWhatsHotData?.forEach(({ mktid, token, class: class1, class2, event, date, Desc }) => {
        //     if (hotList.has(`${mktid}_${token}`)) {
        //         const arrHotList = hotList.get(`${mktid}_${token}`);
        //         arrHotList.push({ color: class1, bg_color: class2, event, date, Desc });
        //         hotList.set(`${(getMktSegIdFromMappedMktSegId(mktid))}_${token}`, arrHotList);
        //     } else {
        //         hotList.set(`${(getMktSegIdFromMappedMktSegId(mktid))}_${token}`, [{ color: class1, bg_color: class2, event, date, Desc }]);
        //     }
        // });

        // for (let i = 0; i < arrAllAlertData?.length; i++) {
        //     if (hotList?.has(arrAllAlertData[i]?.mktIdToken)) {
        //         arrAllAlertData[i].dontMiss = hotList?.get(arrAllAlertData[i]?.mktIdToken);
        //     } else {
        //         arrAllAlertData[i].dontMiss = [];
        //     }
        // }

        const arrActiveAlert = arrAllAlertData?.filter((item) => item.triggered === 0);
        const arrAlertTrigged = arrAllAlertData?.filter((item) => item.triggered === 1);



        return { status: true, message: BUSINESS_LAYER_RESPONSE?.SUCCESS, data: { arrActiveAlert, arrAlertTrigged } };


    } catch (error) {
        console.log(error);
        return { status: false, message: BUSINESS_LAYER_RESPONSE?.FAILURE, error };
    }
};



export { _getAlerts }

